import { request } from '@/common/axios.config'
import { collectAppGroupToken } from '@/common/util-front'

const config = (window.RENDER_DATA && window.RENDER_DATA.syncDo) || []
let reqPrefix = ''
if (
  location.href
    .split('?')[0]
    .split('//')[1]
    .replace(document.domain, '')
    .indexOf(':') != -1 ||
  location.href.indexOf('login.erentalcarpro') != -1
) {
  // location.href
  //   .split('?')[0]
  //   .split('//')[1]
  //   .replace(document.domain, '')
  //   .lastIndexOf('/') == 0 ||
  reqPrefix = ''
} else {
  reqPrefix = '/login'
}
// 本地调试 reqPrefix = '/login'
function checkLogin({ info }) {
  return request({
    url: reqPrefix + '/checkLogin',
    method: 'post',
    data: {
      info
    }
  })
}
function getVerificationCode(data) {
  return request({
    url: reqPrefix + '/getVerificationCode',
    method: 'post',
    data
  })
}

function loginByPhone(data) {
  return request({
    url: reqPrefix + '/loginByPhone',
    method: 'post',
    data
  })
}

function checkUserInfoPassword(data) {
  return request({
    url: reqPrefix + '/checkUserInfoPassword',
    method: 'post',
    data
  })
}

function sendByTemplate(data) {
  return request({
    url: reqPrefix + '/sms',
    method: 'post',
    data
  })
}

async function setToken() {
  let reqPrefix2 = '';
  const list = collectAppGroupToken();
  const p = config.map(item => {
    if (item.includes('login')) {
      reqPrefix2 = ''
    } else {
      reqPrefix2 = '/login'
    }
    return request({
      url: item + reqPrefix2 + '/setToken',
      method: 'post',
      data: {
        list
      }
    })
  })
  const listRes = await Promise.all(p);
  console.log('setToken res', listRes);
  const errObj = listRes.find(item => {
    return !item || item.code !== 0
  })
  if (errObj) {
    console.log('errObj', errObj)
    return Promise.reject(errObj);
  }
  return Promise.resolve({
    code: 0,
    data: null,
    message: 'success'
  });
}

function getPubCode() {
  return request({
    url: reqPrefix + '/getPubCode',
    method: 'get'
  })
}

function changeVerifyCode() {
  return request({
    url: reqPrefix + '/getVerifyCode?d=' + new Date().getTime(),
    method: 'get'
  })
}

function getLangList(lang) {
  return request({
    url: reqPrefix + '/getLangList',
    method: 'post',
    data: {
      lang
    }
  })
}

function setLanguage(language) {
  return request({
    url: reqPrefix + '/setLanguage',
    method: 'post',
    data: {
      language
    }
  })
}
function selectAccount(data) {
  return request({
    url: reqPrefix + '/selectAccount',
    method: 'post',
    data: data
  })
}
function setSsoToken(data) {
  return request({
    url: reqPrefix + '/setSsoToken',
    method: 'post',
    data: data
  })
}
export {
  setToken,
  checkLogin,
  getPubCode,
  changeVerifyCode,
  getLangList,
  setLanguage,
  checkUserInfoPassword,
  sendByTemplate,
  getVerificationCode,
  loginByPhone,
  selectAccount,
  setSsoToken
}
